import { toTitleCaseUi } from "@/shared/utils/titleCase";
import clsx from "clsx";
import type { PropsWithChildren } from "react";
import { getThemeClass, getThemeComponentGroup } from "../lib/themeComponentClasses";

type WrapperInputProps = PropsWithChildren<{
  label?: string;
  error?: string;
  description?: string;
  className?: string;
  required?: boolean;
}>;

export function WrapperInput({
  label,
  error,
  description,
  className,
  children,
  required,
}: WrapperInputProps) {
  const inputClasses = getThemeComponentGroup("input");
  const formSectionClasses = getThemeComponentGroup("formSection");
  const labelText = toTitleCaseUi(label);

  return (
    <div className={clsx("flex flex-col gap-2", className)}>
      {label ? (
        <label
          className={clsx(
            "text-[12px] font-semibold",
            getThemeClass(
              formSectionClasses.labelColor || inputClasses.labelColor,
              "text-theme-text"
            )
          )}
        >
          {labelText}
          {required && <span className="text-red-500"> *</span>}
        </label>
      ) : null}
      {children}
      {description ? (
        <p
          className={clsx(
            "text-xs",
            getThemeClass(formSectionClasses.helperTextColor, "text-theme-text-soft")
          )}
        >
          {description}
        </p>
      ) : null}
      {error ? (
        <p
          className={clsx(
            "text-xs",
            getThemeClass(
              formSectionClasses.errorTextColor || inputClasses.errorTextColor,
              "text-theme-danger-bright"
            )
          )}
        >
          {error}
        </p>
      ) : null}
    </div>
  );
}
